// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageRoomAlternatesDrawerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  locationId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageRoomAlternatesDrawerQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string }, planLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string }, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } }> }> } };

export type SaveDpRplAlternateLocationsMutationVariables = Types.Exact<{
  input: Array<Types.SaveDesignPackageLocationPlanMappingInput> | Types.SaveDesignPackageLocationPlanMappingInput;
}>;


export type SaveDpRplAlternateLocationsMutation = { __typename?: 'Mutation', saveDesignPackageLocationPlanMappings: { __typename?: 'SaveDesignPackageLocationPlanMappingsResult', readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string }> } };


export const DesignPackageRoomAlternatesDrawerDocument = gql`
    query DesignPackageRoomAlternatesDrawer($id: ID!, $rpavId: ID!, $locationId: ID!) {
  designPackage(id: $id, versionId: $rpavId) {
    id
    readyPlanLocations(filter: {alternatesToLocationId: $locationId}) {
      id
      location {
        id
        name
      }
      planLocations {
        id
        location {
          id
          name
        }
        readyPlan {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useDesignPackageRoomAlternatesDrawerQuery__
 *
 * To run a query within a React component, call `useDesignPackageRoomAlternatesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageRoomAlternatesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageRoomAlternatesDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      rpavId: // value for 'rpavId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDesignPackageRoomAlternatesDrawerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables> & ({ variables: DesignPackageRoomAlternatesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>(DesignPackageRoomAlternatesDrawerDocument, options);
      }
export function useDesignPackageRoomAlternatesDrawerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>(DesignPackageRoomAlternatesDrawerDocument, options);
        }
export function useDesignPackageRoomAlternatesDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>(DesignPackageRoomAlternatesDrawerDocument, options);
        }
export type DesignPackageRoomAlternatesDrawerQueryHookResult = ReturnType<typeof useDesignPackageRoomAlternatesDrawerQuery>;
export type DesignPackageRoomAlternatesDrawerLazyQueryHookResult = ReturnType<typeof useDesignPackageRoomAlternatesDrawerLazyQuery>;
export type DesignPackageRoomAlternatesDrawerSuspenseQueryHookResult = ReturnType<typeof useDesignPackageRoomAlternatesDrawerSuspenseQuery>;
export type DesignPackageRoomAlternatesDrawerQueryResult = Apollo.QueryResult<DesignPackageRoomAlternatesDrawerQuery, DesignPackageRoomAlternatesDrawerQueryVariables>;
export const SaveDpRplAlternateLocationsDocument = gql`
    mutation SaveDpRplAlternateLocations($input: [SaveDesignPackageLocationPlanMappingInput!]!) {
  saveDesignPackageLocationPlanMappings(input: $input) {
    readyPlanLocations {
      id
    }
  }
}
    `;
export type SaveDpRplAlternateLocationsMutationFn = Apollo.MutationFunction<SaveDpRplAlternateLocationsMutation, SaveDpRplAlternateLocationsMutationVariables>;

/**
 * __useSaveDpRplAlternateLocationsMutation__
 *
 * To run a mutation, you first call `useSaveDpRplAlternateLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDpRplAlternateLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDpRplAlternateLocationsMutation, { data, loading, error }] = useSaveDpRplAlternateLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDpRplAlternateLocationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDpRplAlternateLocationsMutation, SaveDpRplAlternateLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDpRplAlternateLocationsMutation, SaveDpRplAlternateLocationsMutationVariables>(SaveDpRplAlternateLocationsDocument, options);
      }
export type SaveDpRplAlternateLocationsMutationHookResult = ReturnType<typeof useSaveDpRplAlternateLocationsMutation>;
export type SaveDpRplAlternateLocationsMutationResult = Apollo.MutationResult<SaveDpRplAlternateLocationsMutation>;
export type SaveDpRplAlternateLocationsMutationOptions = Apollo.BaseMutationOptions<SaveDpRplAlternateLocationsMutation, SaveDpRplAlternateLocationsMutationVariables>;